import store from "@/state/store";

export default [
    {
        path: "/logout",
        name: "logout",
        beforeEnter: async (to, from, next) => {
            try {
                await store.dispatch("auth/logout");
            } finally {
                next({ name: "login" });
            }
        },
    },

    {
        path: "/login",
        name: "login",
        meta: { title: "Login" },
        component: () => import("@/app/auth/login.vue"),
    },

    {
        path: "/",
        redirect: "/login"
    },

    // geçici eski template linkleri
    {
        path: "/add-product",
        redirect: "/products/create"
    },

    {
        path: "/mail",
        redirect: "/dashboard"
    },

    // PRODUCT
    {
        path: "/product-list",
        name: "product-list",
        meta: {
            title: "Product List",
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin", "Satis"]
        },
        component: () => import("@/app/products/productList.vue"),
    },

    {
        path: "/products/create",
        name: "product-create",
        component: () => import("@/app/products/create.vue"),
        meta: {
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin", "Satis"]
        }
    },

    {
        path: "/product-update",
        name: "product-update",
        component: () => import("@/app/products/update.vue"),
        meta: {
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin", "Satis"]
        }
    },
    {
    path: "/product-categories",
    name: "product-category-list",
    meta: {
        title: "Kategori Listesi",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis"]
    },
    component: () => import("@/app/productCategories/list.vue")
},

{
    path: "/product-categories/create",
    name: "product-category-create",
    meta: {
        title: "Kategori Ekle",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis"]
    },
    component: () => import("@/app/productCategories/form.vue")
},
{
    path: "/finance",
    name: "finance",
    meta: {
        title: "Gelir / Gider Yönetimi",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis", "Muhasebe"]
    },
    component: () => import("@/app/finance/index.vue")
},
{
    path: "/subscription",
    redirect: { name: "account", query: { tab: "subscription" } }
},
{
    path: "/account",
    name: "account",
    meta: {
        title: "Hesabım",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis", "Muhasebe", "Kullanıcı"]
    },
    component: () => import("@/app/account/index.vue")
},
{
    path: "/documentation",
    name: "documentation",
    meta: {
        title: "Dokümantasyon",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis", "Muhasebe", "Kullanıcı"]
    },
    component: () => import("@/app/documentation/index.vue")
},
{
    path: "/admin/subscriptions",
    name: "subscription-admin",
    meta: {
        title: "Abonelik ve Kupon Yönetimi",
        requiresAuth: true,
        roles: ["Admin"]
    },
    component: () => import("@/app/subscription/admin.vue")
},
{
    path: "/product-categories/:id/edit",
    name: "product-category-update",
    meta: {
        title: "Kategori Güncelle",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis"]
    },
    component: () => import("@/app/productCategories/form.vue")
},

    // CUSTOMER
    {
        path: "/customer-list",
        name: "customer-list",
        meta: {
            title: "Customer List",
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin", "Satis"]
        },
        component: () => import("@/app/customers/list.vue"),
    },

    {
        path: "/customers/create",
        name: "customer-create",
        component: () => import("@/app/customers/create.vue"),
        meta: {
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin", "Satis"]
        }
    },
    {
    path: "/customers/update",
    name: "customer-update",
    component: () => import("@/app/customers/update.vue"),
    meta: {
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis"]
    }
},
{
    path: "/company/settings",
    name: "company-settings",
    meta: {
        title: "Firma Ayarları",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin"]
    },
    component: () => import("@/app/companysettings/settings.vue")
},
{
    path: "/company/branches",
    name: "company-branches",
    meta: {
        title: "Şube Yönetimi",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin"]
    },
    component: () => import("@/app/companysettings/branches.vue")
},
{
    path: "/company/referrals",
    name: "company-referrals",
    meta: {
        title: "Davet / Referans",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin"]
    },
    component: () => import("@/app/companysettings/referrals.vue")
},
{
    path: "/company/branding",
    redirect: { name: "account", query: { tab: "company" } }
},
{
    path: "/invoices/edit",
    name: "invoice-edit",
    meta: {
        title: "Teklif Düzenle",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis"]
    },
    component: () => import("@/app/invoice/edit.vue")
},
{
    path: "/offer/:token",
    name: "public-offer",
    meta: {
        title: "Teklif",
        requiresAuth: false,
        public: true
    },
    component: () => import("@/app/publicoffer/view.vue")
},
{
    path: "/company/custom-fields",
    name: "company-custom-fields",
    meta: {
        title: "Özel Alanlar",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin"]
    },
    component: () => import("@/app/companysettings/customFields.vue")
},
{
    path: "/admin/activity",
    name: "admin-activity",
    meta: {
        title: "Canlı Admin Paneli",
        requiresAuth: true,
        roles: ["Admin"]
    },
    component: () => import("@/app/admin/activity.vue")
},
{
    path: "/dashboard",
    name: "dashboard",
    meta: {
        title: "Firma Paneli",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis"]
    },
    component: () => import("@/app/dashboard/company.vue"),
},
{
    path: "/sales/opportunities",
    name: "sales-opportunities",
    meta: {
        title: "Satış Fırsatları",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis"]
    },
    component: () => import("@/app/opportunities/index.vue")
},
{
    path: "/sales/reports",
    name: "sales-reports",
    meta: {
        title: "Satış Raporları",
        requiresAuth: true,
        roles: ["Admin", "CompanyAdmin", "Satis"]
    },
    component: () => import("@/app/reports/sales.vue")
},

    // COMPANY
    {
        path: "/companies/list",
        name: "company-list",
        meta: {
            title: "Companies",
            requiresAuth: true,
            roles: ["Admin"]
        },
        component: () => import("@/app/companies/list.vue"),
    },

    {
        path: "/companies/create",
        name: "company-create",
        meta: {
            title: "Company Create",
            requiresAuth: true,
            roles: ["Admin"]
        },
        component: () => import("@/app/companies/create.vue"),
    },
    {
    path: "/companies/update",
    name: "company-update",
    meta: {
        title: "Company Update",
        requiresAuth: true,
        roles: ["Admin"]
    },
    component: () => import("@/app/companies/update.vue"),
},

    // TEKLİF / PROFORMA
    {
        path: "/invoices/create",
        name: "invoice-create",
        meta: {
            title: "Teklif Oluştur",
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin", "Satis"]
        },
        component: () => import("@/app/invoice/create.vue"),
    },

    {
        path: "/invoices/view",
        name: "invoice-view",
        meta: {
            title: "Teklif Görüntüle",
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin", "Satis","Muhasebe"]
        },
        component: () => import("@/app/invoice/view.vue"),
    },

    {
        path: "/invoices/list",
        name: "invoice-list",
        meta: {
            title: "Teklif Listesi",
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin", "Satis","Muhasebe"]
        },
        component: () => import("@/app/invoice/list.vue"),
    },

    // USERS
    {
        path: "/users/list",
        name: "user-list",
        meta: {
            title: "Users",
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin"]
        },
        component: () => import("@/app/users/list.vue"),
    },

    {
        path: "/users/create",
        name: "user-create",
        meta: {
            title: "User Create",
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin"]
        },
        component: () => import("@/app/users/create.vue"),
    },

    {
        path: "/users/update",
        name: "user-update",
        meta: {
            title: "User Update",
            requiresAuth: true,
            roles: ["Admin", "CompanyAdmin"]
        },
        component: () => import("@/app/users/update.vue"),
    },

    {
        path: "/unauthorized",
        name: "unauthorized",
        component: () => import("@/app/auth/unauthorized.vue"),
        meta: { title: "Yetkisiz Erişim" }
    },
];
